import jwtInterceptor from '/src/shared/jwtInterceptor'

const apiUrl = process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PATH;

const actions = {
  async getCommission(c,id)
  {
    const url = apiUrl + 'commission/view/'+id;
    const response = await jwtInterceptor.get(url);
    if (response && response.data)
    {
      return response.data
    }
  },
};

export default {
  namespaced: true,
  actions
}